import { isFetchBaseQueryError } from '@afterpaytouch/portal-api'

/**
 * Extracts the underlying API error from an RTK Query error wrapper.
 * RTK Query rejects with { status, data: PortalApiError } while old thunks
 * reject with PortalApiError directly. This normalizes both paths.
 *
 * Temporary helper for the RTK Query migration (PortalRtkQueryMigration flag).
 * Remove when the flag is cleaned up.
 */

export const extractApiError = (useRtkQuery: boolean, error: unknown): unknown =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useRtkQuery && isFetchBaseQueryError(error as any) ? (error as any).data : error
